import { FunctionComponent } from "react";
import NAV from "../components/NAV";

const Lesson31: FunctionComponent = () => {
  return (
    <div className="relative [background:linear-gradient(111.77deg,_rgba(0,_0,_0,_0),_#363636_78.54%),_#0d0d0d] w-full overflow-hidden flex flex-col items-center justify-center pt-[2.69rem] px-[2.69rem] pb-[7.63rem] box-border gap-[6.88rem] text-left text-[1.56rem] text-darkgray font-nunito">
      <NAV dimensionCode="/nav@2x.png" navIconFlexShrink="unset" />
      <div className="self-stretch flex flex-row items-center justify-between">
      <a className="cursor-pointer text-darkgray no-underline" href={"/lesson30"}>
        <div className="flex-1 rounded-32xl bg-gainsboro-200 box-border h-[3.5rem] flex flex-col items-center justify-center py-[0.69rem] px-[3rem] max-w-[12.5rem] border-[1px] border-solid border-gray-300">
          <b className="relative inline-block w-[3.75rem] h-[2.06rem] shrink-0">
            Back
          </b>
        </div>
        </a>
        <div className="self-stretch flex-1 flex flex-col items-center justify-center text-center text-[2.81rem] text-white">
          <b className="self-stretch relative leading-[100%]">
            Nutrition Introduction
          </b>
        </div>
        <a className="cursor-pointer text-darkgray no-underline" href={"/lesson32"}>
        <div className="flex-1 rounded-32xl bg-gainsboro-200 box-border h-[3.5rem] flex flex-col items-center justify-center py-[0.69rem] px-[3rem] max-w-[12.5rem] border-[1px] border-solid border-gray-300">
          <b className="relative inline-block w-[3.75rem] h-[2.06rem] shrink-0">
            Next
          </b>
        </div>
        </a>
      </div>
      <div className="w-full flex flex-col items-center justify-center gap-[9.63rem] max-w-[125rem] text-justify text-[1.88rem] text-white font-dm-sans">
        <div className="self-stretch relative tracking-[0.02em] leading-[2rem]">
          <p className="m-0">
            <b>
              <span>What is Nutrition?</span>
            </b>
          </p>
          <p className="m-0 text-gainsboro-100">
            <span>
              <b>&nbsp;</b>
            </span>
          </p>
          <p className="m-0 text-[1.56rem]">
            <span>
              <span>
                <span>
                  Nutrition is the science of food and how it affects our
                  bodies. It is the study of nutrients, which are substances
                  that our bodies need to function properly. Nutrients can be
                  found in foods and drinks, and they provide us with energy,
                  build and repair tissues, and help us fight off disease.
                </span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>&nbsp;</span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>
                  Food is what fuels you and delivers the calories and nutrients
                  your body needs to function. If your diet is deficient in
                  calories or one or more nutrients, your health may suffer.
                </span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>&nbsp;</span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>
                  Likewise, if you eat too many calories, you may experience
                  weight gain. People with obesity have a significantly
                  increased risk of illnesses like type 2 diabetes, obstructive
                  sleep and heart, liver, and kidney disease.
                </span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>&nbsp;</span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>
                  Additionally, the quality of your diet affects your disease
                  risk, longevity, and mental health.
                </span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>&nbsp;</span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>
                  While diets rich in ultra-processed foods are linked to
                  increased mortality and a greater risk of conditions like
                  cancer and heart disease, diets comprising mostly whole,
                  nutrient-dense foods are associated with increased longevity
                  and disease protection.
                </span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>&nbsp;</span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>
                  Diets rich in highly processed foods may also increase the
                  risk of depressive symptoms, particularly among people who get
                  less exercise.
                </span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>&nbsp;</span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>
                  What’s more, if your current diet is high in ultra-processed
                  foods and beverages like fast food, soda, and sugary cereals
                  but low in whole foods like vegetables, nuts, and fish, you’re
                  likely not eating enough of certain nutrients, which may
                  negatively affect your overall health.
                </span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <b>&nbsp;</b>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <b>&nbsp;</b>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <b>SUMMARY</b>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <b>&nbsp;</b>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>
                  Healthy eating is important for many reasons, including
                  fueling your body, acquiring necessary nutrients, lowering
                  your disease risk, increasing your longevity, and promoting
                  optimal mental and physical well-being.
                </span>
              </span>
            </span>
          </p>
        </div>
        <div className="self-stretch relative tracking-[0.02em] leading-[2rem]">
          <p className="m-0">
            <b>
              <span>The Different Nutrients That the Body Needs</span>
            </b>
          </p>
          <p className="m-0 text-gainsboro-100">
            <span>
              <b>&nbsp;</b>
            </span>
          </p>
          <p className="m-0 text-[1.56rem]">
            <span>
              <span>
                There are six main groups of nutrients that the body needs:
              </span>
            </span>
          </p>
        </div>
        <div className="self-stretch flex flex-row items-center justify-center gap-[6.25rem] text-left">
          <div className="flex-1 relative tracking-[0.02em] leading-[2rem]">
            <p className="m-0">
              <b>
                <span>Carbohydrates</span>
              </b>
            </p>
            <p className="m-0 text-gainsboro-100">
              <span>
                <b>&nbsp;</b>
              </span>
            </p>
            <p className="m-0 text-[1.56rem]">
              <span>
                <span>
                  Carbohydrates are our body's main source of energy. They are
                  found in foods like bread, pasta, rice, fruits, and
                  vegetables.
                </span>
              </span>
            </p>
          </div>
          <img
            className="relative w-[34.63rem] h-[20.81rem] object-cover"
            alt=""
            src="/123@2x.png"
          />
        </div>
        <div className="self-stretch flex flex-row items-center justify-center gap-[6.25rem] text-left">
          <div className="flex-1 relative tracking-[0.02em] leading-[2rem]">
            <p className="m-0">
              <b>
                <span>Fats</span>
              </b>
            </p>
            <p className="m-0 text-gainsboro-100">
              <span>
                <b>&nbsp;</b>
              </span>
            </p>
            <p className="m-0 text-[1.56rem]">
              <span>
                <span>
                  Fats are also a source of energy, and they help our bodies
                  absorb vitamins. They are found in foods like meat, dairy
                  products, nuts, and seeds.
                </span>
              </span>
            </p>
          </div>
          <img
            className="relative w-[34.63rem] h-[19.44rem] object-cover"
            alt=""
            src="/124@2x.png"
          />
        </div>
        <div className="self-stretch flex flex-row items-center justify-center gap-[6.25rem] text-left">
          <div className="flex-1 relative tracking-[0.02em] leading-[2rem]">
            <p className="m-0">
              <b>
                <span>Proteins</span>
              </b>
            </p>
            <p className="m-0 text-gainsboro-100">
              <span>
                <b>&nbsp;</b>
              </span>
            </p>
            <p className="m-0 text-[1.56rem]">
              <span>
                <span>
                  Proteins are essential for building and repairing tissues.
                  They are found in foods like meat, poultry, fish, eggs, dairy
                  products, and beans.
                </span>
              </span>
            </p>
          </div>
          <img
            className="relative w-[34.63rem] h-[22rem] object-cover"
            alt=""
            src="/125@2x.png"
          />
        </div>
        <div className="self-stretch flex flex-row items-center justify-center gap-[6.25rem] text-left">
          <div className="flex-1 relative tracking-[0.02em] leading-[2rem]">
            <p className="m-0">
              <b>
                <span>Vitamins</span>
              </b>
            </p>
            <p className="m-0 text-gainsboro-100">
              <span>
                <b>&nbsp;</b>
              </span>
            </p>
            <p className="m-0 text-[1.56rem]">
              <span>
                <span>
                  Vitamins are essential for many bodily functions, including
                  vision, growth, and immunity. They are found in fruits,
                  vegetables, and whole grains.
                </span>
              </span>
            </p>
          </div>
          <img
            className="relative w-[34.63rem] h-[31.5rem] object-cover"
            alt=""
            src="/126@2x.png"
          />
        </div>
        <div className="self-stretch flex flex-row items-center justify-center gap-[6.25rem] text-left">
          <div className="flex-1 relative tracking-[0.02em] leading-[2rem]">
            <p className="m-0">
              <b>
                <span>Minerals</span>
              </b>
            </p>
            <p className="m-0 text-gainsboro-100">
              <span>
                <b>&nbsp;</b>
              </span>
            </p>
            <p className="m-0 text-[1.56rem]">
              <span>
                <span>
                  Minerals are essential for many bodily functions, including
                  bone health, blood clotting, and muscle contraction. They are
                  found in fruits, vegetables, whole grains, and dairy products.
                </span>
              </span>
            </p>
          </div>
          <img
            className="relative w-[34.63rem] h-[22.63rem] object-cover"
            alt=""
            src="/127@2x.png"
          />
        </div>
        <div className="self-stretch flex flex-row items-center justify-center gap-[6.25rem] text-left">
          <div className="flex-1 relative tracking-[0.02em] leading-[2rem]">
            <p className="m-0">
              <b>
                <span>Minerals</span>
              </b>
            </p>
            <p className="m-0 text-gainsboro-100">
              <span>
                <b>&nbsp;</b>
              </span>
            </p>
            <p className="m-0 text-[1.56rem]">
              <span>
                <span>
                  Minerals are essential for many bodily functions, including
                  bone health, blood clotting, and muscle contraction. They are
                  found in fruits, vegetables, whole grains, and dairy products.
                </span>
              </span>
            </p>
          </div>
          <img
            className="relative w-[34.63rem] h-[26.94rem] object-cover"
            alt=""
            src="/128@2x.png"
          />
        </div>
        <div className="self-stretch relative tracking-[0.02em] leading-[2rem]">
          <p className="m-0">
            <b>
              <span>How the Body Uses Nutrients?</span>
            </b>
          </p>
          <p className="m-0 text-gainsboro-100">
            <span>
              <b>&nbsp;</b>
            </span>
          </p>
          <p className="m-0 text-[1.56rem]">
            <span>
              <span>
                The body uses nutrients in a variety of ways. Carbohydrates are
                broken down into glucose, which is the body's main source of
                energy. Fats are broken down into fatty acids, which are used
                for energy or stored in the body. Proteins are broken down into
                amino acids, which are used to build and repair tissues.
                Vitamins and minerals help the body to function properly.
              </span>
            </span>
          </p>
        </div>
        <div className="self-stretch relative tracking-[0.02em] leading-[2rem] text-[1.56rem]">
          <p className="m-0 text-[1.88rem]">
            <b>
              <span>How to Create a Healthy Diet?</span>
            </b>
          </p>
          <p className="m-0 text-gainsboro-100">
            <span>
              <b>&nbsp;</b>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                A healthy diet is one that provides the body with the nutrients
                it needs to function properly. A healthy diet should include a
                variety of foods from all food groups. It is important to eat
                plenty of fruits, vegetables, and whole grains. It is also
                important to limit processed foods, sugary drinks, and unhealthy
                fats.
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>Here are some tips for creating a healthy diet:</span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <ul className="m-0 pl-[2.06rem]">
            <li className="mb-[0rem]">
              <span>
                <span>Eat plenty of fruits and vegetables.</span>
              </span>
            </li>
          </ul>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <ul className="m-0 pl-[2.06rem]">
            <li className="mb-[0rem]">
              <span>
                <span>Choose whole grains over refined grains.</span>
              </span>
            </li>
          </ul>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <ul className="m-0 pl-[2.06rem]">
            <li className="mb-[0rem]">
              <span>
                <span>Limit processed foods.</span>
              </span>
            </li>
          </ul>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <ul className="m-0 pl-[2.06rem]">
            <li className="mb-[0rem]">
              <span>
                <span>Limit sugary drinks.</span>
              </span>
            </li>
          </ul>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <ul className="m-0 pl-[2.06rem]">
            <li className="mb-[0rem]">
              <span>
                <span>Choose lean protein sources.</span>
              </span>
            </li>
          </ul>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <ul className="m-0 pl-[2.06rem]">
            <li className="mb-[0rem]">
              <span>
                <span>Limit unhealthy fats.</span>
              </span>
            </li>
          </ul>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <ul className="m-0 pl-[2.06rem]">
            <li>
              <span>
                <span>Drink plenty of water.</span>
              </span>
            </li>
          </ul>
        </div>
        <div className="self-stretch relative tracking-[0.02em] leading-[2rem]">
          <p className="m-0">
            <b>
              <span>Nutrient Density</span>
            </b>
          </p>
          <p className="m-0 text-gainsboro-100">
            <span>
              <b>&nbsp;</b>
            </span>
          </p>
          <p className="m-0 text-[1.56rem]">
            <span>
              <span>
                When you conceptualize healthy eating, your first thought might
                be about calories. Even though calories are important, your
                primary concern should be nutrients.
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                That’s because nutrients, including protein, carbs, fat,
                vitamins, and minerals, are what your body needs to thrive.
                “Nutrient density” refers to the amount of nutrients in a food
                in relation to the calories it provides.
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                All foods contain calories, but not all foods are
                nutrient-dense.
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                For example, a candy bar or a box of mac and cheese may be
                incredibly high in calories but lack vitamins, minerals,
                protein, and fibre. Similarly, foods marketed as “diet-friendly”
                or “low calorie” may be very low in calories but lack nutrients.
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                For example, egg whites are much lower in calories and fat than
                whole eggs. However, an egg white provides 1% or less of the
                Daily Value (DV) for iron, phosphorus, zinc, choline, and
                vitamins A and B12, while a whole egg packs 5–21% of the DV for
                these nutrients.
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                That’s because of the nutritious, high fat yolk that eggs
                contain.
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                Plus, although some nutrient-dense foods, such as numerous
                fruits and veggies, are low in calories, many — like nuts, full
                fat yogurt, egg yolks, avocado, and fatty fish — are high in
                calories. That’s perfectly OK!
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                Just because a food is high in calories doesn’t mean that it’s
                bad for you. On the same token, just because a food is low in
                calories doesn’t make it a healthy choice.
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                If your food choices are based solely on calories, you’re
                missing the point of healthy eating.
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                As a general rule, try to mostly eat foods that are high in
                nutrients like protein, fibre, healthy fats, vitamins, and
                minerals. These foods include veggies, fruits, nuts, seeds,
                beans, fatty fish, and eggs.
              </span>
            </span>
          </p>
        </div>
        <div className="self-stretch relative tracking-[0.02em] leading-[2rem]">
          <p className="m-0">
            <b>
              <span>Diet Diversity</span>
            </b>
          </p>
          <p className="m-0 text-gainsboro-100">
            <span>
              <b>&nbsp;</b>
            </span>
          </p>
          <p className="m-0 text-[1.56rem]">
            <span>
              <span>
                Another component of healthy eating is dietary diversity,
                meaning eating a variety of foods.
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                Following a diet that’s rich in different kinds of food supports
                your gut bacteria, promotes a healthy body weight, and protects
                against chronic disease.
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                Still, eating a variety of foods may be difficult if you’re a
                picky eater.
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                If that’s the case, try to introduce new foods one at a time. If
                you don’t eat many vegetables, start by adding a favorite veggie
                to one or two meals per day and build from there.
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                Although you may not enjoy trying new foods, research shows that
                the more you’re exposed to a food, the greater your chances of
                growing accustomed to it.
              </span>
            </span>
          </p>
        </div>
        <div className="self-stretch relative tracking-[0.02em] leading-[2rem]">
          <p className="m-0">
            <b>
              <span>Macronutrient Ratios</span>
            </b>
          </p>
          <p className="m-0 text-gainsboro-100">
            <span>
              <b>&nbsp;</b>
            </span>
          </p>
          <p className="m-0 text-[1.56rem]">
            <span>
              <span>
                Macronutrients — the main nutrients you get from food — are
                carbs, fat, and protein. (Fibre is considered a type of carb.)
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                Generally, your meals and snacks should be balanced between the
                three. In particular, adding protein and fat to fibre-rich carb
                sources makes dishes more filling and tasty.
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                For example, if you’re snacking on a piece of fruit, adding a
                spoonful of nut butter or a bit of cheese helps keep you fuller
                than if you were to eat the fruit alone.
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                However, it’s fine if your diet isn’t balanced all the time.
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                Counting macros and following a set macronutrient plan isn’t
                necessary for most people — except athletes, people seeking a
                specific body composition, and those who need to gain muscle or
                fat for medical reasons.
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                Plus, counting macros and obsessing about staying within a
                certain macro range may lead to an unhealthy fixation with food
                and calories or cause disordered eating tendencies.
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                It’s important to note that some people may thrive on diets that
                are low in carbs and high in fat and protein — or low in fat and
                high in carbs. However, even on these diets, macronutrient
                counting typically isn’t necessary.
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                For example, if you feel your best on a low carb diet, simply
                choosing low carb foods like no starchy veggies, proteins, and
                fats more often than high carb foods will usually suffice.
              </span>
            </span>
          </p>
        </div>
        <div className="self-stretch relative tracking-[0.02em] leading-[2rem]">
          <p className="m-0">
            <b>
              <span>Highly Processed Foods</span>
            </b>
          </p>
          <p className="m-0 text-gainsboro-100">
            <span>
              <b>&nbsp;</b>
            </span>
          </p>
          <p className="m-0 text-[1.56rem]">
            <span>
              <span>
                <span>
                  One of the best ways to improve your diet is to cut back on
                  ultra-processed foods.
                </span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>&nbsp;</span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>
                  You don’t have to avoid processed foods completely. In fact,
                  many healthy foods like shelled nuts, canned beans, and frozen
                  fruits and veggies have been processed in one way or another.
                </span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>&nbsp;</span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>
                  In contrast, highly processed products like soda,
                  mass-produced baked goods, candy, sugary cereals, and certain
                  boxed snack food contain little if any whole food ingredients.
                </span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>&nbsp;</span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>
                  These items tend to pack ingredients like , hydrogenated oils,
                  and artificial sweeteners.
                </span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>&nbsp;</span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>
                  Research links diets high in ultra-processed foods to a
                  greater risk of depression, heart disease, obesity, and many
                  other complications.
                </span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>&nbsp;</span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>
                  On the other hand, diets low in these foods and high in whole,
                  nutrient-dense foods have the opposite effect, protecting
                  against disease, lengthening lifespan, and promoting overall
                  physical and mental well-being.
                </span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>&nbsp;</span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>
                  Thus, it’s best to prioritize nutrient-dense foods, especially
                  vegetables and fruits.
                </span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>&nbsp;</span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>&nbsp;</span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <b>SUMMARY</b>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <b>&nbsp;</b>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>
                  Include a variety of nutrient-dense, whole foods in your diet,
                  taking care to limit highly processed items.
                </span>
              </span>
            </span>
          </p>
        </div>
        <div className="self-stretch relative tracking-[0.02em] leading-[2rem]">
          <p className="m-0">
            <b>
              <span>Optimizing Health by Reducing Certain Foods?</span>
            </b>
          </p>
          <p className="m-0 text-gainsboro-100">
            <span>
              <b>&nbsp;</b>
            </span>
          </p>
          <p className="m-0 text-[1.56rem]">
            <span>
              <span>
                <span>
                  In a healthy diet, it’s best to restrict certain foods.
                </span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>&nbsp;</span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>
                  Decades of scientific research link ultra-processed foods to
                  negative health outcomes, including increased disease risk and
                  early death.
                </span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>&nbsp;</span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>
                  Cutting back on soda, processed meats, candy, ice cream, fried
                  foods, fast food, and highly processed, packaged snacks is a
                  smart way to improve your health and lower your risk of
                  certain diseases.
                </span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>&nbsp;</span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>
                  However, you don’t have to completely avoid these foods all
                  the time.
                </span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>&nbsp;</span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>
                  Instead, try to prioritize whole, nutrient-dense foods like
                  vegetables, fruits, nuts, seeds, beans, and fish, saving
                  highly processed foods and beverages for special treats.
                </span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>&nbsp;</span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>
                  Foods like ice cream and candy can be a part of a healthy,
                  well-rounded diet, but they shouldn’t be a significant part of
                  your calorie intake.
                </span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>&nbsp;</span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <b>&nbsp;</b>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <b>SUMMARY</b>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>&nbsp;</span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>
                  You should limit your intake of ultra-processed foods and
                  drinks like candy, soda, and sugary cereals, but that doesn’t
                  mean that you have to eliminate these items from your diet.
                </span>
              </span>
            </span>
          </p>
        </div>
        <div className="self-stretch relative tracking-[0.02em] leading-[2rem]">
          <p className="m-0">
            <b>
              <span>How to Make Healthy Eating Work For You</span>
            </b>
          </p>
          <p className="m-0 text-gainsboro-100">
            <span>
              <b>&nbsp;</b>
            </span>
          </p>
          <p className="m-0 text-[1.56rem]">
            <span>
              <span>
                Food is one of the many puzzle pieces of your day-to-day life.
                Between commuting, working, family or social commitments,
                errands, and many other daily factors, food may be last on your
                list of concerns.
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                The first step to following a healthier diet is to make food one
                of your priorities.
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                This doesn’t mean that you have to spend hours meal prepping or
                cooking elaborate meals, but it does require some thought and
                effort, especially if you have a particularly busy lifestyle.
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                For example, going to the grocery store once or twice per week
                will help ensure that you have healthy choices in your fridge
                and pantry. In turn, a well-stocked kitchen makes choosing
                healthy meals and snacks much easier.
              </span>
            </span>
          </p>
        </div>
        <div className="self-stretch relative tracking-[0.02em] leading-[2rem] text-[1.56rem]">
          <p className="m-0 text-[1.88rem]">
            <b>
              <span>Grocery Shopping List</span>
            </b>
          </p>
          <p className="m-0 text-gainsboro-100">
            <span>
              <b>&nbsp;</b>
            </span>
          </p>
          <ul className="m-0 text-[1rem] pl-[2.06rem]">
            <li className="mb-[0rem]">
              <span>
                <span>Fresh and frozen fruits and veggies</span>
              </span>
            </li>
          </ul>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <ul className="m-0 pl-[2.06rem]">
            <li className="mb-[0rem]">
              <span>
                <span>Protein sources like chicken, eggs, fish, and tofu</span>
              </span>
            </li>
          </ul>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <ul className="m-0 pl-[2.06rem]">
            <li className="mb-[0rem]">
              <span>
                <span>
                  Bulk carb sources like canned beans and whole grains
                </span>
              </span>
            </li>
          </ul>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <ul className="m-0 pl-[2.06rem]">
            <li className="mb-[0rem]">
              <span>
                <span>
                  Starchy veggies like white potatoes, sweet potatoes, and
                  butternut squash
                </span>
              </span>
            </li>
          </ul>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <ul className="m-0 pl-[2.06rem]">
            <li className="mb-[0rem]">
              <span>
                <span>
                  Fat sources like avocados, olive oil, and full fat yogurt
                </span>
              </span>
            </li>
          </ul>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <ul className="m-0 pl-[2.06rem]">
            <li className="mb-[0rem]">
              <span>
                <span>
                  Nutritious, simple snack ingredients like nuts, seeds, nut
                  butter, hummus, olives, and dried fruit
                </span>
              </span>
            </li>
          </ul>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                If you’re drawing a blank at mealtime, keep it simple and think
                in threes:
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <ul className="m-0 pl-[2.06rem]">
            <li className="mb-[0rem]">
              <span>
                <span>
                  Protein: eggs, chicken, fish, or a plant-based option like
                  tofu
                </span>
              </span>
            </li>
          </ul>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <ul className="m-0 pl-[2.06rem]">
            <li className="mb-[0rem]">
              <span>
                <span>
                  Fat: olive oil, nuts, seeds, nut butter, avocado, cheese, or
                  full fat yogurt
                </span>
              </span>
            </li>
          </ul>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <ul className="m-0 pl-[2.06rem]">
            <li className="mb-[0rem]">
              <span>
                <span>
                  Fibre-rich carbs: starchy options like sweet potatoes, oats,
                  certain fruits, and beans — or low carb fibre sources like
                  asparagus, broccoli, cauliflower, and berries
                </span>
              </span>
            </li>
          </ul>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                For example, breakfast could be a spinach and egg scramble with
                avocado and berries, lunch a sweet potato stuffed with veggies,
                beans, and shredded chicken, and dinner a salmon filet or baked
                tofu with sautéed broccoli and brown rice.
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                If you’re not used to cooking or grocery shopping, focus on a
                single meal. Go to the grocery store and shop for the
                ingredients for a couple of breakfast or dinner dishes for the
                week. Once that becomes a habit, add more meals until most of
                your meals are prepared at home.
              </span>
            </span>
          </p>
        </div>
        <div className="self-stretch relative tracking-[0.02em] leading-[2rem]">
          <p className="m-0">
            <b>
              <span>Healthy Relationship With Food</span>
            </b>
          </p>
          <p className="m-0 text-gainsboro-100">
            <span>
              <b>&nbsp;</b>
            </span>
          </p>
          <p className="m-0 text-[1.56rem]">
            <span>
              <span>
                If you don’t have a good relationship with food, you’re not
                alone.
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                Many people have disordered eating tendencies or eating
                disorders. If you’re concerned that you have one of these
                conditions, it’s critical to get the right help.
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                To develop a healthy relationship with food, you have to have
                the right tools.
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                Working with a healthcare team, such as a registered dietitian
                and psychologist who specializes in eating disorders, is the
                best way to start mending your relationship with food.
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                Food restrictions, fad dieting, and self-prescribed notions like
                “getting back on track” won’t help and may be harmful. Working
                on your relationship with food may take time, but it’s necessary
                for your physical and mental health.
              </span>
            </span>
          </p>
        </div>
        <div className="self-stretch relative tracking-[0.02em] leading-[2rem] text-[1.56rem]">
          <p className="m-0 text-[1.88rem]">
            <b>
              <span>Tips For Healthy Eating in the Real World</span>
            </b>
          </p>
          <p className="m-0 text-gainsboro-100">
            <span>
              <b>&nbsp;</b>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>
                  Here are some realistic tips for you to get started with
                  healthy eating:
                </span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>&nbsp;</span>
              </span>
            </span>
          </p>
          <ul className="m-0 pl-[2.06rem]">
            <li className="mb-[0rem]">
              <span>
                <span>
                  <b className="font-dm-sans">{`Prioritize plant-based foods. `}</b>
                  <span>
                    Plant foods like veggies, fruits, beans, and nuts should
                    make up the majority of your diet. Try incorporating these
                    foods, especially veggies and fruits, at every meal and
                    snack.
                  </span>
                </span>
              </span>
            </li>
          </ul>
          <p className="m-0">
            <span>
              <span>
                <span>&nbsp;</span>
              </span>
            </span>
          </p>
          <ul className="m-0 pl-[2.06rem]">
            <li className="mb-[0rem]">
              <span>
                <span>
                  <b className="font-dm-sans">Cook at home.</b>
                  <span>
                    {" "}
                    Cooking meals at home helps diversify your diet. If you’re
                    used to takeout or restaurant meals, try cooking just one or
                    two meals per week to start.
                  </span>
                </span>
              </span>
            </li>
          </ul>
          <p className="m-0">
            <span>
              <span>
                <span>&nbsp;</span>
              </span>
            </span>
          </p>
          <ul className="m-0 pl-[2.06rem]">
            <li className="mb-[0rem]">
              <span>
                <span>
                  <b className="font-dm-sans">Shop for groceries regularly.</b>
                  <span>
                    {" "}
                    If your kitchen is stocked with healthy foods, you’re more
                    likely to make healthy meals and snacks. Go on one or two
                    grocery runs per week to keep nutritious ingredients on
                    hand.
                  </span>
                </span>
              </span>
            </li>
          </ul>
          <p className="m-0">
            <span>
              <span>
                <span>&nbsp;</span>
              </span>
            </span>
          </p>
          <ul className="m-0 pl-[2.06rem]">
            <li className="mb-[0rem]">
              <span>
                <span>
                  <b className="font-dm-sans">{`Understand that your diet isn’t going to be perfect. `}</b>
                  <span>
                    Progress — not perfection — is key. Meet yourself where you
                    are. If you’re currently eating out every night, cooking one
                    homemade, veggie-packed meal per week is significant
                    progress.
                  </span>
                </span>
              </span>
            </li>
          </ul>
          <p className="m-0">
            <span>
              <span>
                <b>&nbsp;</b>
              </span>
            </span>
          </p>
          <ul className="m-0 pl-[2.06rem]">
            <li className="mb-[0rem]">
              <span>
                <span>
                  <b>“Cheat days” aren’t acceptable.</b>
                  <span>
                    {" "}
                    If your current diet includes “cheat days” or “cheat meals,”
                    this is a sign that your diet is unbalanced. Once you learn
                    that all foods can be a part of a healthy diet, there’s no
                    need for cheating.
                  </span>
                </span>
              </span>
            </li>
          </ul>
          <p className="m-0">
            <span>
              <span>
                <span>&nbsp;</span>
              </span>
            </span>
          </p>
          <ul className="m-0 pl-[2.06rem]">
            <li className="mb-[0rem]">
              <span>
                <span>
                  <b className="font-dm-sans">{`Cut out sugar-sweetened drinks. `}</b>
                  <span>
                    Limit sugary beverages like soda, energy drinks, and
                    sweetened coffees as much as possible. Regularly consuming
                    sugary beverages may harm your health.
                  </span>
                </span>
              </span>
            </li>
          </ul>
          <p className="m-0">
            <span>
              <span>
                <b>&nbsp;</b>
              </span>
            </span>
          </p>
          <ul className="m-0 pl-[2.06rem]">
            <li className="mb-[0rem]">
              <span>
                <span>
                  <b>{`Choose filling foods. `}</b>
                  <span>
                    When you’re hungry, your goal should be to eat filling,
                    nutritious foods, not to eat as few calories as possible.
                    Pick protein- and fibre-rich meals and snacks that are sure
                    to fill you up.
                  </span>
                </span>
              </span>
            </li>
          </ul>
          <p className="m-0">
            <span>
              <span>
                <span>&nbsp;</span>
              </span>
            </span>
          </p>
          <ul className="m-0 pl-[2.06rem]">
            <li className="mb-[0rem]">
              <span>
                <span>
                  <b className="font-dm-sans">Eat whole foods.</b>
                  <span>
                    {" "}
                    A healthy eating pattern should be primarily composed of
                    whole foods like vegetables, fruits, beans, nuts, seeds,
                    whole grains, and protein sources like eggs and fish.
                  </span>
                </span>
              </span>
            </li>
          </ul>
          <p className="m-0">
            <span>
              <span>
                <b>&nbsp;</b>
              </span>
            </span>
          </p>
          <ul className="m-0 pl-[2.06rem]">
            <li className="mb-[0rem]">
              <span>
                <span>
                  <b>Hydrate the smart way.</b>
                  <span>
                    {" "}
                    Staying hydrated is part of healthy eating, and water is the
                    best way to stay hydrated. If you’re not used to drinking
                    water, get a reusable water bottle and add fruit slices or a
                    squeeze of lemon for flavor.
                  </span>
                </span>
              </span>
            </li>
          </ul>
          <p className="m-0">
            <span>
              <span>
                <b>&nbsp;</b>
              </span>
            </span>
          </p>
          <ul className="m-0 pl-[2.06rem]">
            <li className="mb-[0rem]">
              <span>
                <span>
                  <b>Honor your dislikes.</b>
                  <span>
                    {" "}
                    If you’ve tried a specific food several times and don’t like
                    it, don’t eat it. There are plenty of healthy foods to
                    choose instead. Don’t force yourself to eat something just
                    because it’s considered healthy.
                  </span>
                </span>
              </span>
            </li>
          </ul>
          <p className="m-0">
            <span>
              <span>
                <span>&nbsp;</span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>
                  These tips can help you move toward a healthier diet.
                </span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>&nbsp;</span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>
                  You can also work with a registered dietitian, especially if
                  you’re not sure how to start improving your diet. A dietitian
                  can help you develop a sustainable, nutritious eating plan
                  that works for your needs and schedule.
                </span>
              </span>
            </span>
          </p>
        </div>
        <div className="self-stretch relative tracking-[0.02em] leading-[2rem] text-[1.56rem]">
          <p className="m-0 text-[1.88rem]">
            <b>
              <span>SUMMARY</span>
            </b>
          </p>
          <p className="m-0 text-gainsboro-100">
            <span>
              <b>&nbsp;</b>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                Tips like cooking at home, grocery shopping, eating a lot of
                plant foods, choosing filling meals and snacks, and honoring
                your dislikes can help you create and maintain a healthy eating
                pattern.
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <ul className="m-0 pl-[2.06rem]">
            <li className="mb-[0rem]">
              <span>
                <span>
                  Eat at least 5 portions of a variety of fruit and vegetables
                  every day
                </span>
              </span>
            </li>
          </ul>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <ul className="m-0 pl-[2.06rem]">
            <li className="mb-[0rem]">
              <span>
                <span>Cut down on saturated fat and sugar</span>
              </span>
            </li>
          </ul>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <ul className="m-0 pl-[2.06rem]">
            <li className="mb-[0rem]">
              <span>
                <span>Get active and be a healthy weight / body fat</span>
              </span>
            </li>
          </ul>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <ul className="m-0 pl-[2.06rem]">
            <li className="mb-[0rem]">
              <span>
                <span>
                  Base meals on higher fibre starchy foods like potatoes, bread,
                  rice or pasta
                </span>
              </span>
            </li>
          </ul>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <ul className="m-0 pl-[2.06rem]">
            <li className="mb-[0rem]">
              <span>
                <span>
                  Have some dairy or dairy alternatives (such as soya drinks)
                </span>
              </span>
            </li>
          </ul>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <ul className="m-0 pl-[2.06rem]">
            <li className="mb-[0rem]">
              <span>
                <span>
                  Eat some beans, pulses, fish, eggs, meat and other protein
                </span>
              </span>
            </li>
          </ul>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <ul className="m-0 pl-[2.06rem]">
            <li className="mb-[0rem]">
              <span>
                <span>
                  Choose unsaturated oils and spreads, and eat them in small
                  amounts
                </span>
              </span>
            </li>
          </ul>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <ul className="m-0 pl-[2.06rem]">
            <li>
              <span>
                <span>
                  Drink plenty of fluids (at least 6 to 8 glasses a day)
                </span>
              </span>
            </li>
          </ul>
        </div>
        <a className="cursor-pointer text-darkgray no-underline" href={"/lesson32"}>
        <div className="rounded-32xl bg-gainsboro-200 box-border w-[25rem] flex flex-col items-center justify-center pt-[0.69rem] px-[3rem] pb-[1rem] max-w-[31.25rem] text-center text-[1.88rem] border-[1px] border-solid border-gray-300">
          <b className="self-stretch relative">Next Chapter</b>
        </div>
      </a>
      </div>
    </div>
  );
};

export default Lesson31;
